<div
  *ngIf="!labelTemplate"
  [ngClass]="getLabelClass()">
  {{label}}
</div>
<ng-template *ngTemplateOutlet="labelTemplate"></ng-template>